__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@aviv-unified-frontend/branded-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.1.0", () => (() => (__webpack_require__(9031))), 1);
			register("@aviv-dxp/react-thor", "2.25.9", () => (() => (__webpack_require__(1995))), 1);
			register("@aviv-trak/feature-flagging", "1.5.1", () => (() => (__webpack_require__(5231))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "11.0.4", () => (() => (__webpack_require__(1282))), 1);
			register("@aviv-unified-frontend/runtime/brand", "11.0.4", () => (() => (__webpack_require__(8491))), 1);
			register("@aviv-unified-frontend/runtime/environment", "11.0.4", () => (() => (__webpack_require__(7363))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "11.0.4", () => (() => (__webpack_require__(8197))), 1);
			register("@aviv-unified-frontend/runtime/head", "11.0.4", () => (() => (__webpack_require__(7204))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "11.0.4", () => (() => (__webpack_require__(6710))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "11.0.4", () => (() => (__webpack_require__(6136))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "11.0.4", () => (() => (__webpack_require__(6568))), 1);
			register("@aviv-unified-frontend/runtime/router", "11.0.4", () => (() => (__webpack_require__(1213))), 1);
			register("@aviv-web-core/tracking", "1.3.0", () => (() => (__webpack_require__(7566))), 1);
			register("@gemini/core", "3.7.0", () => (() => (__webpack_require__(8319))), 1);
			register("@react-aria/focus", "3.22.0", () => (() => (__webpack_require__(6182))), 1);
			register("@react-aria/i18n", "3.13.0", () => (() => (__webpack_require__(8670))), 1);
			register("@react-aria/interactions", "3.28.0", () => (() => (__webpack_require__(2989))), 1);
			register("@react-aria/overlays", "3.32.0", () => (() => (__webpack_require__(7979))), 1);
			register("@react-aria/ssr", "3.10.0", () => (() => (__webpack_require__(4261))), 1);
			register("@react-aria/toast", "3.1.0", () => (() => (__webpack_require__(6186))), 1);
			register("@react-aria/utils", "3.34.0", () => (() => (__webpack_require__(1381))), 1);
			register("@react-stately/overlays", "3.7.0", () => (() => (__webpack_require__(4197))), 1);
			register("@react-stately/toast", "3.2.0", () => (() => (__webpack_require__(8845))), 1);
			register("react-dom/client", "19.2.5", () => (() => (__webpack_require__(725))), 1);
			register("react-dom/server", "19.2.5", () => (() => (__webpack_require__(8463))), 1);
			register("react-dom", "19.2.5", () => (() => (__webpack_require__(7708))), 1);
			register("react/jsx-runtime", "19.2.5", () => (() => (__webpack_require__(1627))), 1);
			register("react", "19.2.5", () => (() => (__webpack_require__(1979))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};